import { getCountry, getLanguageIso2, setChosenLanguage } from '../modules/i18n';

const i18nData = Promise.all([getCountry(), getLanguageIso2()]);

document.addEventListener('jb-cookie-consent:connected', (event: Event) => {
  const { element } = (event as CustomEvent).detail;
  i18nData.then(([country, languageIso2]) => {
    element.country = country || undefined;
    element.currentLanguageIso2 = languageIso2 || undefined;
  });
});

// Switching language in the cookie-consent overlay persists the new language as the visitor's
// preferred language, so the apex redirect takes them there on their next visit.
document.addEventListener('jb-cookie-consent:language-changed', (event: Event) => {
  const { languageIso2 } = (event as CustomEvent).detail;
  if (languageIso2) {
    setChosenLanguage(languageIso2);
  }
});
